module.exports = __webpack_public_path__ + "img/bg.d795e4e9.png";